import { render, staticRenderFns } from "./investiWork.vue?vue&type=template&id=4732a8e4"
import script from "./investiWork.vue?vue&type=script&lang=js"
export * from "./investiWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4732a8e4')) {
      api.createRecord('4732a8e4', component.options)
    } else {
      api.reload('4732a8e4', component.options)
    }
    module.hot.accept("./investiWork.vue?vue&type=template&id=4732a8e4", function () {
      api.rerender('4732a8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/investiWork.vue"
export default component.exports